import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
//import { InstantSearch } from "react-instantsearch-hooks";
//import { SearchMethodParams } from "algoliasearch/lite";

/*
const searchClient = algoliasearch(
  "latency",
  "a4390aa69f26de2fd0c4209ff113a4f9"
);*/

//import { liteClient } from "algoliasearch/lite";

//const searchClient = liteClient("latency", "a4390aa69f26de2fd0c4209ff113a4f9");

//const INDEX_NAME = "autocomplete_twitter_accounts";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);
